import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getBannersThunk, setBannersThunk } from './bannersThunk';
import { IState } from 'types/Banner';

const initialState: IState = {
	banners: [],
};

export const getBanners = createAsyncThunk(
	'banners/getBanners',
	getBannersThunk,
);

export const setBanners = createAsyncThunk(
	'banners/setBanners',
	setBannersThunk,
);

const bannersSlice = createSlice({
	name: 'form',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder
			.addCase(getBanners.fulfilled, (state, { payload }) => {
				state.banners = payload.data;
			})
			.addCase(getBanners.rejected, (state, { payload }) => {
				state.banners = [];
			});
	},
});

export default bannersSlice.reducer;
